/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Search_Foot_FilteringInputs */

const en_search_foot_filtering = /** @type {(inputs: Search_Foot_FilteringInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`filtering ${i?.count} endpoints`)
};

const zh_hans1_search_foot_filtering = /** @type {(inputs: Search_Foot_FilteringInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在筛选 ${i?.count} 个接口`)
};

const pt_br2_search_foot_filtering = /** @type {(inputs: Search_Foot_FilteringInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`filtrando ${i?.count} endpoints`)
};

const es_search_foot_filtering = /** @type {(inputs: Search_Foot_FilteringInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`filtrando ${i?.count} endpoints`)
};

const fr_search_foot_filtering = /** @type {(inputs: Search_Foot_FilteringInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`filtrage de ${i?.count} endpoints`)
};

const de_search_foot_filtering = /** @type {(inputs: Search_Foot_FilteringInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Endpoints werden gefiltert`)
};

const ru_search_foot_filtering = /** @type {(inputs: Search_Foot_FilteringInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`фильтрация эндпоинтов: ${i?.count}`)
};

const it_search_foot_filtering = /** @type {(inputs: Search_Foot_FilteringInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`filtraggio di ${i?.count} endpoint`)
};

/**
* | output |
* | --- |
* | "filtering {count} endpoints" |
*
* @param {Search_Foot_FilteringInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_foot_filtering = /** @type {((inputs: Search_Foot_FilteringInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Foot_FilteringInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_foot_filtering(inputs)
	if (locale === "pt-BR") return pt_br2_search_foot_filtering(inputs)
	if (locale === "es") return es_search_foot_filtering(inputs)
	if (locale === "fr") return fr_search_foot_filtering(inputs)
	if (locale === "de") return de_search_foot_filtering(inputs)
	if (locale === "ru") return ru_search_foot_filtering(inputs)
	if (locale === "it") return it_search_foot_filtering(inputs)
	return en_search_foot_filtering(inputs)
});